import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const images = [
  "IMG_0904.jpg",
  "IMG_0993.jpg",
  "IMG_1070.jpg",
  "IMG_1092.jpg",
  "IMG_1104.jpg",
  "IMG_1107.jpg",
  "IMG_1110.jpg",
  "IMG_1116.jpg",
  "IMG_1124.jpg",
  "IMG_1136.jpg",
  "IMG_1141.jpg",
  "IMG_1146.jpg",
  "IMG_1149.jpg",
  "IMG_1155.jpg",
  "IMG_1161.jpg",
  "IMG_1165.jpg",
  "IMG_1173.jpg",
  "IMG_1186.jpg",
];

function Image() {
  return (
    <>
      <Header />

      {/* Page Header */}
      <div className="page-header bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  Our gallery
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Photo Gallery */}
      <div className="page-gallery">
        <div className="container">
          <div className="row gallery-items page-gallery-box">
            {images.map((img, index) => (
              <div className="col-lg-4 col-6" key={index}>
                <div
                  className="photo-gallery wow fadeInUp"
                  data-wow-delay={`${index * 0.1}s`}
                >
                  <Link to={`images/${img}`} data-cursor-text="View">
                    <figure className="image-anime">
                      <img src={`images/${img}`} alt={`Gallery ${index + 1}`} />
                    </figure>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Image;
